const questionTypes = {
  sexSelector: 'sex_selector',
  dropdown: 'dropdown',
  numberInput: 'number_input',
  rangeInput: 'range_input',
  questionGroup: 'question_group',
};

export default questionTypes;
